import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { EmojiComponent } from '@core/symbol-legacy';
import { ButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-reaction-button',
  templateUrl: './reaction-button.component.html',
  styleUrls: ['./reaction-button.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonComponent, EmojiComponent],
})
export class ReactionButtonComponent {
  public readonly reaction = input<string>(undefined!);
  public readonly counter = input<number>(undefined!);
  public readonly isActive = input<boolean>(undefined!);
}
